module.exports = "pegasus_template/assets/global-style.png";